@if (page == "home") {
  <div
    class="reviewContainer d-flex"
    #parent
    (mousedown)="startDragging($event, false, slider)"
    (mouseup)="stopDragging($event, false)"
    (mouseleave)="stopDragging($event, false)"
    (mousemove)="moveEvent($event, slider)"
  >
    @for (item of creatorReviews; track item; let i = $index) {
      <div class="reviewSec dCenter flex-column" [ngClass]="'r' + i">
        <div
          class="head w-100 mb-3 d-flex justify-content-between align-items-center"
        >
          <p class="gilroy-b mb-0 wow fadeInDown">{{ item?.name }}</p>
          <div class="rating dCenter">
            <fa-icon [icon]="faStar"></fa-icon>
            {{ item?.rating }}
          </div>
        </div>
        <p class="gilroy-m reviewP mb-0 wow fadeInDown">{{ item?.review }}</p>
      </div>
    }
  </div>
} @else {
  <div
    id="reviewContainer"
    class="reviewContainer d-flex"
    #parent
    (mousedown)="startDragging($event, false, slider)"
    (mouseup)="stopDragging($event, false)"
    (mouseleave)="stopDragging($event, false)"
    (mousemove)="moveEvent($event, slider)"
  >
    @for (item of creatorReviews; track item) {
      @if (!loading) {
        <div class="reviewSec dCenter flex-column">
          <div
            class="head w-100 mb-3 d-flex justify-content-between align-items-center"
          >
            <div class="leftSide dCenter">
              <div class="reviewBox dCenter oHideBox rounded-circle">
                <img
                class="lazyImage"
                  defaultImage="https://res.cloudinary.com/yfhy4efp/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
                  [useSrcset]="true"
                  [lazyLoad]="item?.image"
                  width="100%"
                  height="100%"
                  alt="Image"
                />
              </div>
              <p class="gilroy-b mb-0 wow fadeInDown">{{ item?.name }}</p>
            </div>
            <div class="rating dCenter">
              <fa-icon [icon]="faStar"></fa-icon>
              {{ item?.rating }}
            </div>
          </div>
          <p class="gilroy-m reviewP mb-0 wow fadeInDown">{{ item?.comment }}</p>
        </div>
      } @else {
        <div class="reviewSec skeleton"></div>
      }
    }
  </div>
  @if (!creatorReviews?.length) {
    <p class="text-center">No Reviews Yet</p>
  }
}
